<!--  -->
<template>
	<!-- 线上培训 -->
	<div class='online'>
		<div class="Bread_crumbs">
			<div class="Bread_crumbs_box">
				<el-breadcrumb separator-class="el-icon-arrow-right" class="mbx_a_1">
					<el-breadcrumb-item :to="{ path: '/home' }">
						<span class="Bread_crumbs_box_2">
							<i class="iconfont">&#xe625;</i>
						</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/user/learning/index' }">
						<span class="Bread_crumbs_box_1">学习中心</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span class="Bread_crumbs_box_1">学习中心</span>
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<div class="collect_title">
			<div class="collect_title_x">
				<ul class="collect_title_ul_1">
					<p>学习状态: </p>
					<li v-for="(item,index) in statusOptions" @click="favoritechange(item.value,item.label)"
						:class="item.value==studyStatus?'collect_title_li_active' :'collect_title_li'">{{ item.label }}
					</li>
				</ul>
			</div>
		</div>
		<el-form ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
			<el-form-item label="关键字" prop="keyword">
				<el-input v-model="keyword" placeholder="请输入关键字" clearable size="small"
					@keyup.enter.native="handleQuery" />
			</el-form-item>
			<!-- <el-form-item label="学习状态" prop="studyStatus">
		  	<el-select v-model="studyStatus" clearable placeholder="请选择" size="small">
		  	    <el-option
		  	      v-for="item in statusOptions"
		  	      :key="item.value"
		  	      :label="item.label"
		  	      :value="item.value">
		  	    </el-option>
		  	</el-select>
		  </el-form-item> -->
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
				<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="list" style="width:100%;">
			<el-table-column width="65">
				<template slot-scope="scope" prop="photo">
					<el-image :fit="fit" style="width: 50px; height: 35px" :src="scope.row.photo"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="项目名称" align="center" prop="name" />
			<el-table-column label="开始时间" align="center" width="180" prop="itemBeginTime" />
			<el-table-column label="结束时间" align="center" width="180" prop="itemEndTime" />
			<el-table-column label="项目状态" align="center" prop="status">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.status == 2">进行中</el-tag>
					<el-tag v-if="scope.row.status == 1" type="success">未开始</el-tag>
					<el-tag v-if="scope.row.status == 3" type="info">已结束</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="是否发证" align="center" prop="isCert">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.isCert == 'Y'" type="success">{{scope.row.cert.name}}</el-tag>
					<el-tag v-if="scope.row.isCert == 'N'" type="info">不发证</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="学习状态" align="center" prop="projectStatus">
				<template slot-scope="scope">
					<router-link :to="'/project/info/'+scope.row.projectPeriodCode" target="_blank">
						<el-tag v-if="scope.row.userStudy.studyStutas == 2">去学习</el-tag>
					</router-link>
					<el-tag v-if="scope.row.userStudy.studyStutas == 1" type="success">未开始</el-tag>
					<el-tag v-if="scope.row.userStudy.studyStutas == 3" type="info">已结束</el-tag>
				</template>
			</el-table-column>

		</el-table>
		<!--分页-->
		<div class="pagination_box" v-if="total > 0">
			<el-pagination :current-page.sync="pageNum" @current-change="handleCurrentChange" :page-size="pageSize"
				layout="total, prev, pager, next" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/user/cultivate.less"
	export default {
		name: 'online',
		data() {
			//这里存放数据
			return {
				fit: 'contain',
				list: [],
				pageNum: 1,
				pageSize: 10,
				total: null,
				keyword: null,
				// 显示搜索条件
				showSearch: true,
				studyStatus: null,
				statusOptions: [{
					value: '0',
					label: '未订阅'
				}, {
					value: '1',
					label: '未开始'
				}, {
					value: '2',
					label: '进行中'
				}, {
					value: '3',
					label: '已完成'
				}],
			}
		},
		components: {},

		//方法集合
		methods: {
			// 学习状态
			favoritechange(value, name) {
				this.studyStatus = value
				// this.statKindname = name
				this.getList()
			},
			getList() {
				var _this = this;
				_this.$api.userProjectList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					keyword: this.keyword,
					studyStatus: this.studyStatus,
				}).then(res => {
					if (res.code == 200) {
						_this.total = res.data.total;
						_this.list = res.data.list;
					} else {
						_this.$message.error(res.msg);
					}
				}).catch(function (error) {
					_this.$message.error(error.msg);
				});
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getList();
			},
			/** 搜索按钮操作 */
			handleQuery() {
				this.pageNum = 1;
				this.getList();
			},
			/** 重置按钮操作 */
			resetQuery() {
				this.keyword = null;
				this.studyStatus = null;
				this.handleQuery();
			},
		},
		created() {
			this.pageNum = 1;
			this.getList();
		},
		mounted() {
			this.pageNum = 1;
			this.getList();
		}
	}
</script>
<style scoped>

</style>